import React from 'react';
import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import { FeatureLinkItem } from 'types';
import './FeaturedElements.scss';

interface FeaturedElementsProps {
  featuredLink: FeatureLinkItem | undefined;
  l0Title: string;
  handleMouseEnterOnLinks: () => void;
  handleMouseLeaveOnLinks: () => void;
}

const FeaturedElements = ({
  featuredLink,
  l0Title,
  handleMouseEnterOnLinks,
  handleMouseLeaveOnLinks,
}: FeaturedElementsProps) => {
  const formatDataEm = (text: string) => {
    const replacedText = text.replace('Featured:', '');
    return `TopNav_Featured:${l0Title}_${replacedText.replace(/ /g, '')}`;
  };

  return (
    <div className="featured-element-container hmf-pb-xs" id="featuredElementsContainer">
      {featuredLink?.cta?.map((cta, index) => (
        <ErrorBoundaryWithLogger componentId="FeaturedElements" key={JSON.stringify(cta)}>
          <a
            className="featured-element l0-link-content hmf-display-flex hmf-align-items-center hmf-px-s hmf-py-xxs title-color hmf-body-bold-m"
            id={`featured-element-${index}`}
            tabIndex={0}
            aria-label={`Open ${cta.linkTitle}`}
            href={cta.link}
            onMouseEnter={() => handleMouseEnterOnLinks()}
            onMouseLeave={() => handleMouseLeaveOnLinks()}
            data-em={formatDataEm(cta.linkTitle)}>
            {cta.linkTitle}
          </a>
        </ErrorBoundaryWithLogger>
      ))}
    </div>
  );
};

export default FeaturedElements;
